import { Injectable } from '@angular/core';

@Injectable()
export class ConfigurationService {
  alert:string[] = [];
}
